// improve this one as well
// we can use the convection of records filteredview
// tell me if you need it uploaded
// import React from "react";

// const ReadOnlyRow = ({
//   isLoadingDelete,
//   contact,
//   handleEditClick,
//   handleDeleteClick,
//   handleDownloadRow
// }) => {
//   return (
//     <tr className="trrows hover-red bg-white ">
//       <td className="bg-gold">{contact.id}</td>
//       <td>{contact.farmerid}</td>
//       <td>{contact.username}</td>
//       <td>{contact.email}</td>
//       <td>{contact.password}</td>
//       <td>{contact.phone}</td>
//       <td style={{ whiteSpace: "nowrap" }}>{contact.joined}</td>
//       <td style={{ whiteSpace: "nowrap" }}>{contact.company}</td>

//       <td>{contact.lastactive}</td>
//       <td>{contact.category}</td>
//       <td>{contact.status}</td>

//       <td>

//           <label className=" hover-bg-transparent"onClick={(event) => handleEditClick(event, contact)}>
//             <i className="fas fa-edit f2 hover-gold"></i>
           
//           </label>
   
    
         
//          <label className="ml2 hover-bg-transparent"  onClick={() => handleDeleteClick(contact.id)}>
//             <i className="fas fa-trash f2 hover-yellow red"></i>
          
//           </label>
//       </td>
//     </tr>
//   );
// };

// export default ReadOnlyRow;



// new and improved
import React from "react";

const ReadOnlyRow = ({
  contact,
  handleEditClick,
  handleDeleteClick,
  selectedRecords = [],
  handleSelectRecord = () => {},
  deletingId, // id of the row currently being deleted, or null
}) => {
  const isDeleting = deletingId === contact.id;

  const statusValue = String(contact?.status || "").toLowerCase();

  // FIX: colors the status pill based on actual status instead of just
  // printing the raw string, so it's scannable at a glance like the
  // Approved/Not Approved badges in Records.
  const statusBadgeClass =
    statusValue === "active"
      ? "bg-light-green dark-green b--green"
      : statusValue === "disabled"
      ? "bg-washed-red dark-red b--light-red"
      : "bg-light-yellow dark-yellow b--gold"; // pending / unknown

  return (
    <tr className={`trrows hover-red bg-white ${isDeleting ? "o-50" : ""}`}>
      {/* Select */}
      <td className="tc">
        <input
          type="checkbox"
          checked={selectedRecords.includes(contact.id)}
          onChange={() => handleSelectRecord(contact.id)}
        />
      </td>
      <td className="bg-gold">{contact.id}</td>
      <td>{contact.farmerid}</td>
      <td>{contact.username}</td>
      <td>{contact.email}</td>
      <td>{contact.password}</td>
      <td>{contact.phone}</td>
      <td style={{ whiteSpace: "nowrap" }}>{contact.joined}</td>
      <td style={{ whiteSpace: "nowrap" }}>{contact.company}</td>
      <td>{contact.lastactive}</td>
      <td>{contact.category}</td>
      <td>
        <span className={`dib br-pill ph3 pv1 f7 fw6 ba ${statusBadgeClass}`}>
          {contact.status || "-"}
        </span>
      </td>
      <td>
        <label
          className="hover-bg-transparent"
          onClick={(event) => handleEditClick(event, contact)}
        >
          <i className="fas fa-edit f2 hover-gold"></i>
        </label>

        <label
          className="ml2 hover-bg-transparent"
          onClick={() => !isDeleting && handleDeleteClick(contact.id)}
          title={isDeleting ? "Deleting..." : "Delete"}
        >
          {isDeleting ? (
            <i className="fas fa-spinner fa-spin f2 red"></i>
          ) : (
            <i className="fas fa-trash f2 hover-yellow red"></i>
          )}
        </label>
      </td>
    </tr>
  );
};

export default ReadOnlyRow;